import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from '../../api';
import { Gate } from '../../schema/gate';

interface GateFromInputProps {
  required?: boolean;
  value?: number | null;
  gateIds?: number[];
  onChange?: (value: number | null) => void;
}

const GateFromInput: React.FC<GateFromInputProps> = ({
  required,
  value,
  gateIds,
  onChange
}: GateFromInputProps) => {
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [gateList, setGateList] = useState<Gate[]>([]);
  const [selectedValue, setSelectedValue] = useState<Gate | null>(null);

  useEffect(() => {
    const searchParams = new URLSearchParams();
    gateIds?.forEach((gate_id) => {
      searchParams.append('id', `${gate_id}`);
    });
    searchParams.set('not_inid', 'true');

    if (value != null) {
      const gate = gateList.find((data) => data.id == value);
      if (gate) {
        setSelectedValue(gate);
        return;
      }
      api.get<Gate>(`/gate/${value}`).then((res) => {
        const { data } = res;
        setSelectedValue(data);
        setGateList([data]);
      });
    } else {
      // searchParams.append('limit', `10`);
      api.get<Gate[]>(`/gate`, { params: searchParams }).then((res) => {
        const { data } = res;
        setGateList(data);
      });

      setSelectedValue(null);
    }
  }, [value]);

  useEffect(() => {
    if (searchKeyword) {
      const timeOut = setTimeout(() => {
        const searchParams = new URLSearchParams();
        gateIds?.forEach((gate_id) => {
          searchParams.append('id', `${gate_id}`);
        });
        searchParams.set('not_inid', 'true');
        searchParams.set('name', searchKeyword);
        // searchParams.set('limit', '10');
        api.get<Gate[]>(`/gate`, { params: searchParams }).then((res) => {
          const { data } = res;
          setGateList(data);
        });
      }, 500);
      return () => clearTimeout(timeOut);
    }
  }, [searchKeyword]);
  return (
    <Autocomplete
      options={gateList}
      getOptionLabel={(option) => (option?.gate_name ? option.gate_name : '')}
      renderInput={(params) => (
        <TextField {...params} label="ประตู" required={required} placeholder="ประตู" />
      )}
      onChange={(_, value) => onChange && onChange(value ? value.id : null)}
      value={selectedValue}
      onInputChange={(_, newInputValue) => {
        setSearchKeyword(newInputValue);
      }}
      isOptionEqualToValue={(option, v) => v?.id == option?.id}
      fullWidth
    />
  );
};

export default GateFromInput;
